import { useAppContext } from '@/hooks/useAppContext';

/**
 * Returns the origin to use when building shareable URLs (QR codes,
 * remote-login callbacks, etc). Prefers `config.shareOrigin` when set,
 * otherwise falls back to `window.location.origin`.
 *
 * The returned value never has a trailing slash.
 */
export function useShareOrigin(): string {
  const { config } = useAppContext();
  const configured = config.shareOrigin?.replace(/\/+$/, '');
  if (configured) return configured;
  return typeof window !== 'undefined' ? window.location.origin : '';
}
